<template>
  <div v-if="pageDevice != null && isLoginUserPageItemWritable">
    <deviceTabs :current="'report'" :pageDevice="pageDevice" :pageUser="pageUser" />
    <div class="m-0 mt-3 mr-2" v-if="this.pageDevice.disabled == true">
      <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger">
        정지 중이므로 기기의 인증코드를 설정할 수 없습니다.
      </b-alert>
    </div>

    <p class="mt-2 pt-0 gothic">
      팅커블 IoT 기기설정에서 상태보고서 사용과 전송이 모두 '사용'인 경우 에러나 이상 상황이 발생하면 내부의 플래쉬 메모리에 시스템 상태 보고서를 저장하고 일정한 크기 이상이 되면 서버로 전송됩니다. 상태 보고서는 최근 200개 항목까지만 저장됩니다.
    </p>

    <div class="mt-1 p-1 pl-2 gothic border bg-secondary-lighter fontSizeDot8">
      <b-form-checkbox v-for="field in reportGridFieldsAll" :key="field.key" class="d-inline-block ml-2 mr-2" v-model="reportGridShowFields[field.key]" >
        <span style="vertical-align: middle" v-b-tooltip.hover :title="field.title">{{ field.label }}</span>
      </b-form-checkbox>
    </div>

    <b-table v-touch:swipe.stop id="reportTable" class="mt-2 logGrid" striped bordered hover :fields="reportGridFields" :items="pageDevice.reports" tdClass="fontSizeDot9" thStyle="font-size: 0.8rem; color: red;">
    </b-table>

    <div class="text-right mr-2 mt-2">

      <b-button type="button" size="sm" class="mr-2" @click="updateReports" variant="primary" :disabled="!this.pageBinded">
        상태 보고서 갱신
      </b-button>

      <b-button type="button" size="sm" @click="removeReports" variant="danger" :disabled="!this.pageBinded">
        <b-spinner small type="grow" class="mr-1" v-if="this.showRemoveSpinner"></b-spinner>
        모두 지우기
      </b-button>

    </div>



  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"

import uiUtil from "@/mixins/util.js"
import mapUtil from "@/mixins/mapUtil.js"
import user from "@/mixins/user.js"
import functions from "@/mixins/functions.js"

import deviceTabs from "@/components/device/deviceTabs.vue"

export default {
  name: "deviceReport",
  mixins: [uiUtil, mapUtil, user, functions],
  props: {
    pageUser: Object,
    pageDevice: Object,
    pageBinded: Boolean,
  },
  components: {
    deviceTabs,
  },

  data: function() {
    return {
      errorTypes: [
        "",
        "격리 사이즈 초과",
        "WiFi 재시도 최대값 초과",
        "업데이이트 에러 최대값 초과",
        "힙 메모리 부족",
        "스택 메모리 부족"
      ],
      reportGridShowFields: {
        "added": false,
        "type": false,
        "saved": true,
        "millis": false,
        "body": true,
        "wifiErr" : false,
        "updateErr" : false,
        "freeHeap" : false,
        "conStack" : false,
        "totalBytes" : false,
        "usedBytes" : false,
        "isolatedBytes": false,
        "isolatedCount": false,
      },

      reportGridFieldsAll: [
        {
          key: "added",
          label: "업로드",
          sortable: true,
          title: "서버에 업로드된 시간입니다.",
          formatter: value => {
            if(!value) return "";
            else return this.dateToString(new Date(value))
          },
          tdClass: "p-dot1 text-center fontSizeDot7",
          thClass: "fontSizeDot8"
        },
        {
          key: "type",
          label: "에러",
          title: "에러 내용입니다.",
          sortable: true,
          formatter: value => {
            if(value>= 0 && value <=5) {
              return this.errorTypes[value];
            }
            else {
              return "";
            }
          },
          tdClass: "p-dot1 text-center fontSizeDot8",
          thClass: "fontSizeDot8"
        },
        {
          key: "saved",
          label: "저장",
          title: "기기에서 저장된 시간입니다.",
          sortable: true,
          // formatter: value => {
          //   if(!value) return "";
          //   else return this.dateToString(new Date(value))
          // },
          tdClass: "p-dot1 text-center fontSizeDot7",
          thClass: "fontSizeDot8"
        },
        {
          key: "millis",
          label: "부팅",
          title: "저장시점에서 부팅후 경과시간입니다. 단위는 ms입니다.",
          sortable: true,
          tdClass: "p-dot1 text-right fontSizeDot7",
          thClass: "fontSizeDot8"
        },
        {
          key: "body",
          label: '내용',
          title: "상태 보고 내용입니다.",
          sortable: true,
          tdClass: "p-dot1 text-left fontSizeDot8",
          thClass: "fontSizeDot8"
        },
        {
          key: "wifiErr",
          label: "연결시도",
          title: "부팅 후 WiFi 연결시도 횟수입니다.",
          sortable: true,
          tdClass: "p-dot1 text-right fontSizeDot8",
          thClass: "fontSizeDot8"
        },
        {
          key: "updateErr",
          label: '업데이트 에러',
          title: "부팅 후 데이터 업데이트 에러 횟수입니다.",
          sortable: true,
          tdClass: "p-dot1 text-right fontSizeDot8",
          thClass: "fontSizeDot8"
        },
        {
          key: "freeHeap",
          label: '비어있는 힙',
          sortable: true,
          title: "비어있는 힙 메모리 용량입니다. 단위는 Bytes입니다.",
          tdClass: "p-dot1 text-right fontSizeDot8",
          thClass: "fontSizeDot8"
        },
        {
          key: "conStack",
          label: '연결된 스택',
          sortable: true,
          title: "비어있는 연결된 스택메모리 용량입니다. 단위는 Bytes입니다.",
          tdClass: "p-dot1 text-right fontSizeDot8",
          thClass: "fontSizeDot8"
        },
        {
          key: "totalBytes",
          label: '전체',
          sortable: true,
          title: "플래쉬 메모리 최대크기입니다. 단위는 Bytes입니다.",
          tdClass: "p-dot1 text-right fontSizeDot8",
          thClass: "fontSizeDot8"
        },
        {
          key: "usedBytes",
          label: '사용',
          sortable: true,
          title: "사용된 플래쉬 메모리 크기입니다. 단위는 Bytes입니다.",
          tdClass: "p-dot1 text-right fontSizeDot8",
          thClass: "fontSizeDot8"
        },
        {
          key: "isolatedBytes",
          label: '격리',
          title: "격리된 파일의 크기입니다. 단위는 Bytes입니다. -1은 격리 폴더가 없다는 뜻입니다.",
          sortable: true,
          tdClass: "p-dot1 text-right fontSizeDot8",
          thClass: "fontSizeDot8"
        },
        {
          key: "isolatedCount",
          label: '격리수',
          sortable: true,
          title: "격리된 파일의 수입니다.",
          tdClass: "p-dot1 text-right fontSizeDot8",
          thClass: "fontSizeDot8"
        },
      ],
      showRemoveSpinner: false,
    }
  },
  mounted: function() {
  },
  computed: {
    reportGridFields: function() {
      return this.reportGridFieldsAll.filter(item=> {
        return this.reportGridShowFields[item.key]
      });
    },
  },
  methods: {
    updateReports: function() {
      if(this.pageDevice.reports.length >0) {
        this.$set(this.pageDevice.reports, this.pageDevice.reports.length-1, this.pageDevice.reports[this.pageDevice.reports.length-1]);
      }
      this.$root.$emit('bv::refresh::table', 'reportTable');
    },

    removeReports: function() {
      this.showRemoveSpinner = true
      db.collection("devices").doc(this.pageDevice.id).update({
        reports : [],
        "lastModified": firebase.firestore.FieldValue.serverTimestamp()
      })
      .then(()=> {
        this.showRemoveSpinner = false;
        this.makeToast("success", "상태보고서 삭제 성공", "상태 보고서를 모두 지웠습니다.");
      })
      .catch(error => {
        this.showRemoveSpinner = false;
        this.makeToast("danger", "상태보고서 삭제 실패", "에러가 발생했습니다. 에러: " + error);
      })
    }
  },
}
</script>
